import * as zamsForZed from "@zams/logger/zed";
import { LogParams } from "@zams/logger/zed/generated/loggerMapType";
import { Amplify } from "aws-amplify";
import { record } from "aws-amplify/analytics";

export function generateDefaultParams(urlParams: URLSearchParams) {
  const paramKeys = [
    'appVersion', 
    'make', 
    'modelNumber', 
    'platformVersion', 
    'adId', 
    'uuid',
    'appsflyerId',
    'deviceIP',
    'user_no', 
    'mkt',
    'business',
    'domain',
    'who_session',
    'adid_original',
    'zid', 
    'os',
    'zedVersion',
    'platform',
  ];

  let params = Object.fromEntries(
    Array.from(urlParams.entries()).
    filter(([k0]) => paramKeys.includes(k0)).
    map(([k1, v1]) => {
      let result = '';
      if (!!v1 && v1.length > 0) result = v1;
      if (!!v1 && v1.length > 200) result = v1.substring(0, 200);

      return [k1, result]; }
    )) as LogParams;

  // adid 가 없을 경우 예외처리
  if (!params.adId) {
    if (params.domain === 'hogangnono') {
      params.adId = params.who_session ?? '';
    } else if (params.domain === 'www' || params.domain === 'm') {
      params.adId = params.zid ?? '';
    }
  }

  params.modelVersion = urlParams.get('modelNumber') ?? '';
  params.domain = urlParams.get('domain') ?? 'test';

  return params;
}

export const initializePinpoint = (srcParams: URLSearchParams) => {  
  Amplify.configure({
      Auth: {
        Cognito: {          
          identityPoolId: srcParams.get('identityPoolId')!,
          allowGuestAccess: true,
        }
      },
      Analytics: {
        Pinpoint: {
          appId: srcParams.get('appId')!,
          region: srcParams.get('region')!,
          bufferSize: 3000,
          flushInterval: 1000 * 3,
          flushSize: 300,
          resendLimit: 3,
        }
      }
    }
  );

  const params = generateDefaultParams(srcParams);
  params.modelVersion = srcParams.get('modelNumber') ?? '';
  const stage = srcParams.get('stage');

  zamsForZed.initLog({
    defaultParams: params,
    onInvalid: (error) => {
      if (stage !== 'prod') {
        console.error(`zed pinpoint(${error.zamsId}, ${stage}): `, error.error);
      }
      return true;
    },
    logFunction: (zamsId, name, { defaults, managed }) => {
      const attributes = { ...defaults, ...managed }
      if (stage !== 'prod') {
        console.log(`zed pinpoint(${zamsId}): `, name, attributes);
      }
      return Promise.resolve(record({ name, attributes }));      
    },
  })
}
